export const GET_ALL_COMPANIES = "GET_ALL_COMPANIES";
export const COMPANY_IS_LOADING = "COMPANY_IS_LOADING";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const COMPANY_MODAL = "CompanyModal";
export const REMOVE_COMPANY = "REMOVE_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const RESET_COMPANY_MESSAGE = 'RESET_COMPANY_MESSAGE'
